module.exports = __webpack_public_path__ + "static/media/truck.04dfc4c3.svg";